export const BUSINESS_INFORMATION_COMPANY_LEGAL_NAME = 'businessInformation.companyLegalName'
export const BUSINESS_INFORMATION_BUSINESS_REGISTRATION_NUMBER = 'businessInformation.businessRegistrationNumber'
export const BUSINESS_ADDRESS_ADDRESS_LINE1 = 'businessAddress.addressLine1'
export const BUSINESS_ADDRESS_CITY = 'businessAddress.city'
export const BUSINESS_ADDRESS_COUNTRY = 'businessAddress.country'
export const COMPANY_EMAIL_CONTACT_BUSINESS_DEPT = 'contactInformation.business'
export const COMPANY_EMAIL_CONTACT_DEVELOPMENT_DEPT = 'contactInformation.development'
export const PAYMENT_INFORMATION = 'paymentInformation'
export const COMPANY_EMAIL_CONTACT_FINANCIAL_DEPT = 'contactInformation.financial'
export const USER_HAS_NECESSARY_RIGHT_CONFIRMATION_IS_CHECKED = 'user_has_necessary_right_confirmation_is_checked'
